/**
 * Serializes a params object into url param form "key1=value1&key2=value2".
 *
 * @param params params object
 * @returns serialized string
 */
export const simpleParamsSerializer = (params: Record<string, string | number | boolean> = {}): string => Object.entries(params)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');
